// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import Component from "../../../../app/lib/jGia/jGia/src/Component";
import eventbus from "../../../../app/lib/jGia/jGia/src/eventbus";
import Cookies from "js-cookie";

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import logger from "../../../../app/baseUtilities/logger";
import validate_refEl from "../../../../app/baseUtilities/validate/validate_refEl.js";
import cancel_featInit from "../../../../app/baseUtilities/cancel/cancel_featureInit";
import cancel_ebh from "../../../../app/baseUtilities/cancel/cancel_ebh.js";

// —————————————————————————————————————— INITIALIZATION F() —————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import init_openModalBtn from "./init/init_openModalBtn.js";
import init_slideSetBtns from "./init/init_slideSetBtns.js";
import init_controls from "./init/init_controls.js";
import init_closeBtn from "./init/init_closeBtn.js";
import init_cta_dontShowAgain from "./init/init_cta_dontShowAgain.js";

// ————————————————————————————— EVENT/EVENTBUS/STATE CHANGE HANDLERS ————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import stChH_ctaState_dontShowAgain from "./stateChangeHandlers/stChH_ctaState_dontShowAgain.js";
import stChH_slideCounterMax from "./stateChangeHandlers/stChH_slideCounterMax.js";
import stChH_activeSlideSetID from "./stateChangeHandlers/stChH_activeSlideSetID.js";
import stChH_activeSlideIndex from "./stateChangeHandlers/stChH_activeSlideIndex.js";
import stChH_hidden from "./stateChangeHandlers/stChH_hidden.js";
import stChH_mode from "./stateChangeHandlers/stChH_mode.js";

import ebh_window_resize from "./eventbusHandlers/ebh_window_resize.js";

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// Options with case-sensitive keys that are not to be
// automatically extracted from the options arg. but be
// assigned to an option key manually to preserve its case
// (Kirby CMS converts all fields/option keys to lowercase)
// (see constructor).

const manualOptionKeys = ["optionkey"];

//  Default values for manually extracted options
//  (see constructor, in case specific option has not been provided
//  in comp. config.).

const defaultOptions = {
  optionkey: { foo: "bar" },
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

class InfoModal extends Component {
  ///////////////////////////// Constructor //////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  constructor(element, options) {
    super(element);

    ///////// DOM references //////////
    ///////////////////////////////////

    this.ref = {
      closeBtn: null,
      prevBtn: null,
      nextBtn: null,
      openModalBtn: null,
      slideSets: [],
      slides: [],
      slideSetBtns: [],
      activeSlideIndexDisplay: null,
      slideCounterMaxDisplay: null,
      cta_dontShowAgain: null,
    };

    //////////// Options /////////////
    //////////////////////////////////

    // Get options not to be manually extracted from the options arg...
    const autoOptions = {};
    for (const key in options) if (!manualOptionKeys.includes(key)) autoOptions[key] = options[key];

    this.options = {
      name: "InfoModal",
      version: element.getAttribute("g-version") ?? "1",
      // optionKey: options.optionkey,
      ...autoOptions,
    };

    //////////// Utilities /////////////
    ////////////////////////////////////

    this.logger = logger.bind(this);
    this.validate_refEl = validate_refEl.bind(this);
    this.cancel_featInit = cancel_featInit.bind(this);
    this.cancel_ebh = cancel_ebh.bind(this);

    //////////// Init. f() /////////////
    ////////////////////////////////////

    this.init_cta_dontShowAgain = init_cta_dontShowAgain.bind(this);
    this.init_openModalBtn = init_openModalBtn.bind(this);
    this.init_slideSetBtns = init_slideSetBtns.bind(this);
    this.init_controls = init_controls.bind(this);
    this.init_closeBtn = init_closeBtn.bind(this);

    ///////////// Modules //////////////
    ////////////////////////////////////

    // ...

    /////////////// API ////////////////
    ////////////////////////////////////

    this.api = {
      hideComp: () => this.setState({ hidden: true }),
      showComp: () => this.setState({ hidden: false }),
    };

    //////// Eventbus listeners ////////
    ////////////////////////////////////

    this.ebl_window_resize = ebh_window_resize.bind(this);

    ////// State-change listeners //////
    ////////////////////////////////////

    this.stChL_ctaState_dontShowAgain = stChH_ctaState_dontShowAgain.bind(this);
    this.stChL_slideCounterMax = stChH_slideCounterMax.bind(this);
    this.stChL_activeSlideSetID = stChH_activeSlideSetID.bind(this);
    this.stChL_activeSlideIndex = stChH_activeSlideIndex.bind(this);
    this.stChL_hidden = stChH_hidden.bind(this);
    this.stChL_mode = stChH_mode.bind(this);

    ////// Custom event handlers ///////
    // (To be passed to parent class) //

    ///////// Pre-mount init. //////////
    ////////////////////////////////////

    // ...
  }

  //////////////////////////////// Mount /////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  mount() {
    this.logger("info", ["mounting"], "action", { inline: true });
    this.init();
  }

  /////////////////////////////// Unmount ////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  unmount() {
    this.logger("info", ["unmounting"], "action", { inline: true });

    ///////////////////////////////////
    // Unregister eventbus listeners //
    ///////////////////////////////////

    eventbus.off("window_resize", this.ebl_window_resize);

    /////////////////////////////
    // API call deregistration //
    /////////////////////////////

    eventbus.off("NewComponent.api.hideComp", this.api.hideComp);
    eventbus.off("NewComponent.api.showComp", this.api.showComp);
  }

  ///////////////////////////////// Init. ////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  init() {
    this.setState({ mode: "init", hidden: Cookies.get("UdKAss_hideInfoModal") === "true" });
    this.init_cta_dontShowAgain();
    this.init_openModalBtn();
    this.init_slideSetBtns();
    this.init_controls();
    this.init_closeBtn();
    this.init_eventbus();
    this.init_states();
    this.setState({ mode: "ready" });
  }

  ////////////////////////////////////
  ////////////////////////////////////

  init_states() {
    this.logger("init", ["states"], "action", { inline: true });
    this.setState({
      activeSlideSetID: "0",
      activeSlideIndex: 0,
      is_mobile: window.innerWidth < 640,
    });
  }

  ////////////////////////////////////
  ////////////////////////////////////

  init_eventbus() {
    this.logger("init", ["eventbus"], "action", { inline: true });

    /////////////////////////////////
    // Register eventbus listeners //
    /////////////////////////////////

    eventbus.on("window_resize", this.ebl_window_resize);

    ///////////////////////////
    // API call registration //
    ///////////////////////////

    eventbus.on("NewComponent.api.hideComp", this.api.hideComp);
    eventbus.on("NewComponent.api.showComp", this.api.showComp);
  }

  //////////////////////////// State Changes /////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  stateChange(CHANGES) {
    ////// ctaState_dontShowAgain //////
    ////////////////////////////////////

    if ("ctaState_dontShowAgain" in CHANGES) this.stChL_ctaState_dontShowAgain(CHANGES);

    ///////// slideCounterMax /////////
    ////////////////////////////////////

    if ("slideCounterMax" in CHANGES) this.stChL_slideCounterMax(CHANGES);

    ///////// activeSlideSetID /////////
    ////////////////////////////////////

    if ("activeSlideSetID" in CHANGES) this.stChL_activeSlideSetID(CHANGES);

    ///////// activeSlideIndex /////////
    ////////////////////////////////////

    if ("activeSlideIndex" in CHANGES) this.stChL_activeSlideIndex(CHANGES);

    ////////////// hidden //////////////
    ////////////////////////////////////

    if ("hidden" in CHANGES) this.stChL_hidden(CHANGES);

    /////////////// mode ///////////////
    ////////////////////////////////////

    if ("mode" in CHANGES) this.stChL_mode(CHANGES);
  }
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default InfoModal;
